import _pipe from "ramda/src/pipe";
import qs from 'qs';
import { isString } from "../../../browser/is";
import { couldBeValidNumber, mapDeepWithArr, flattenKeysFrom } from "./lib";
export var parseValueType = function parseValueType(val) {
  if (!isString(val)) return val;
  if (/^'.*'$/.test(val)) return val.replace(/^'|'$/g, '');
  if (/^".*"$/.test(val)) return val.replace(/^"|"$/g, '');
  if (couldBeValidNumber(val)) return +val;
  if (val === 'true') return true;
  if (val === 'false') return false;
  return val;
};
export var serializeValueType = function serializeValueType(val) {
  if (val === undefined) return undefined;
  if (!isString(val)) return "".concat(val);
  if (couldBeValidNumber(val)) return "\"".concat(val, "\"");
  if (val === 'true') return '"true"';
  if (val === 'false') return '"false"';
  return val;
};
export var parse = _pipe(function (str) {
  return qs.parse(str, {
    plainObjects: true,
    depth: 10,
    ignoreQueryPrefix: true,
    arrayLimit: 100
  });
}, mapDeepWithArr(parseValueType));
export var serialize = _pipe(mapDeepWithArr(serializeValueType), function (query) {
  return qs.stringify(query, {
    arrayFormat: 'indices',
    sort: function sort(left, right) {
      return left.localeCompare(right);
    }
  });
});
export var flatten = flattenKeysFrom('');